import { DatePicker, Input, Select, Space } from 'antd';
import React from 'react';

import { PROGRAM_NAME_OPTIONS } from '../constants';
import {
  ORDER_STATUS_OPTIONS,
  PAYMENT_OPTIONS,
  RATING_OPTIONS,
} from './constants';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;

export const Filters = () => {
  return (
    <Space size="middle" wrap>
      <div className={styles.filterContainer}>
        <p>課程：</p>
        <Select
          allowClear
          showSearch
          placeholder="請選擇或輸入課程名稱"
          optionFilterProp="label"
          className={styles.filter}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={PROGRAM_NAME_OPTIONS}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>會員：</p>
        <Input
          allowClear
          placeholder="請輸入會員名字或手機號碼"
          className={styles['w-15']}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>狀態：</p>
        <Select
          allowClear
          placeholder="請選擇狀態"
          className={styles.filter}
          options={ORDER_STATUS_OPTIONS}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>訂單編號：</p>
        <Input
          allowClear
          placeholder="請輸入訂單編號"
          className={styles.filter}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>日期：</p>
        <RangePicker
          placeholder={['起始日期', '結束日期']}
          className={styles['w-15']}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>付費方式：</p>
        <Select
          allowClear
          placeholder="請選擇付費方式"
          className={styles.filter}
          options={PAYMENT_OPTIONS}
        />
      </div>

      <div className={styles.filterContainer}>
        <p>滿意度(5星)：</p>
        <Select
          allowClear
          placeholder="請選擇滿意度"
          className={styles.filter}
          options={RATING_OPTIONS}
        />
      </div>
    </Space>
  );
};
